import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { CustomPopover } from '../../../cs/common/components/custom-popover';
import { IWWCharacter } from '../../../common/model/graphql-types';
import { WWCharacterPopover } from './ww-character-popover';

interface IProps {
  employee: IWWCharacter;
  enablePopover?: boolean;
  showLabel?: boolean;
  showTags?: boolean;
  showIcon?: boolean;
  showTierListchange?: boolean;
  showEidolon?: boolean;
  eidolonSpecial?: boolean;
}

export const WWCharacterCard: React.FC<IProps> = ({
  employee,
  showLabel,
  enablePopover,
  showIcon
}) => {
  const image = employee.cardImage
    ? getImage(employee.cardImage.localFile.childImageSharp)
    : null;
  return (
    <CustomPopover
      enabled={enablePopover}
      customClass="character-hover-box ww"
      popover={<WWCharacterPopover character={employee} />}
    >
      <Link to={'/wuthering-waves/characters/' + employee.slug}>
        <div
          className={`avatar card ww rarity-${employee.rarity} ${
            showLabel ? showLabel : ''
          }`}
        >
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${employee.name}`}
            />
          )}
          {showLabel && <span className="emp-name">{employee.name}</span>}
          {showLabel && employee.isNew && <span className="tag new">New</span>}
          {showLabel && employee.upcoming && (
            <>
              {employee.slug === 'zani' || employee.slug === 'ciaccona' ? (
                <span className="tag future">2.3</span>
              ) : (
                <span className="tag future">2.4</span>
              )}
            </>
          )}
        </div>
        {showIcon && (
          <span className="floating-element">
            {employee.element === 'Aero' && (
              <>
                <StaticImage
                  src="../../../../images/ww/icons/element_aero.png"
                  alt={employee.element}
                />
              </>
            )}
            {employee.element === 'Electro' && (
              <>
                <StaticImage
                  src="../../../../images/ww/icons/element_electro.png"
                  alt={employee.element}
                />
              </>
            )}
            {employee.element === 'Fusion' && (
              <>
                <StaticImage
                  src="../../../../images/ww/icons/element_fusion.png"
                  alt={employee.element}
                />
              </>
            )}
            {employee.element === 'Glacio' && (
              <>
                <StaticImage
                  src="../../../../images/ww/icons/element_glacio.png"
                  alt={employee.element}
                />
              </>
            )}
            {employee.element === 'Havoc' && (
              <>
                <StaticImage
                  src="../../../../images/ww/icons/element_havoc.png"
                  alt={employee.element}
                />
              </>
            )}
            {employee.element === 'Spectro' && (
              <>
                <StaticImage
                  src="../../../../images/ww/icons/element_spectro.png"
                  alt={employee.element}
                />
              </>
            )}
          </span>
        )}
      </Link>
    </CustomPopover>
  );
};
